import * as action_types from '../actions/action_types';

const initialState = {
  isCorrect: true,
};

export const HomePageReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case action_types.CHECK_ROUTE:
      return {
        ...state,
        isCorrect: action.data.isCorrect,
      };
    default:
      return state;
  }
};
